"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _Modal = require("@insided/shared/uikit/Modal");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var PauseSystemEmailsModal = function PauseSystemEmailsModal(props) {
  var isOpen = props.isOpen,
      onPauseClick = props.onPauseClick,
      _onClose = props.onClose;
  return (0, _preact.h)(_Modal.Modal, {
    isOpen: isOpen,
    size: "medium"
  }, (0, _preact.h)(_Modal.ModalHeader, {
    title: "Pause all system emails?",
    onClose: function onClose() {
      return _onClose();
    }
  }), (0, _preact.h)(_Modal.ModalBody, null, (0, _preact.h)("p", null, "This will disable ALL system emails from going out, including password reset emails and account confirmation emails."), (0, _preact.h)("br", null), (0, _preact.h)("p", null, "For this reason, we strongly recommend that you put your community in Offline mode first. You can do this in", ' ', (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)("/settings/configuration/visibility"),
    target: "_blank",
    rel: "noreferrer"
  }, "Platform Visibility"), ' ', "settings.")), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_Button.default, {
    title: "Pause",
    onClick: onPauseClick,
    size: "medium",
    variant: "warning",
    "data-track-type": "click",
    "data-element-name": "Pause system email button"
  }), (0, _preact.h)(_Button.default, {
    title: "Cancel",
    onClick: _onClose,
    size: "medium",
    "data-track-type": "click",
    "data-element-name": "Cancel button"
  })));
};

var _default = PauseSystemEmailsModal;
exports.default = _default;